
/*
Author: Srinivas P
Date: 04/12/2019
Description: When clicked on Add New Legal Entity in Profile Icon,there is Update button instead of Save Button
search_string: editmode PL-1989
*/
<template>
  <div>
    <header class="navbar">
      <div class="d-header">
        <div v-if="ifAdmin && !legalEntityPage" class="legalentityName">{{this.legalEntities[this.$route.params.entity_index].legalName+" : "+this.legalEntities[this.$route.params.entity_index].clientCode }}</div>
        <div v-if="ifAdmin && legalEntityPage" class="legalentityName">{{this.orgData.name }}</div>
        <div class="backdrop"></div>
        <!-- <div class="d-header__title cursor" @click="gotoHome"><img class="sidenavLogo" src="@/assets/dashboard/logo.svg" alt /></div> -->
        <div class="d-spacer"></div>
        <div class="d-header__right">
          <!-- <div class="d-header__search" v-show="!ifAuditor">
            <button type="button" class="headerSearchIcon">
              <i class="material-icons Icon">search</i>
            </button>
            <input type="text" placeholder="Search" class="searchText" />
          </div> -->
          <div class="d-header__links">
            <!-- <div class="links" v-show="!ifAuditor">
              <span class="icon-chat"></span>
            </div> -->
            <!-- <div class="links" v-show="!ifAuditor">
              <span class="icon-bell"></span>
            </div> -->
            <div class="links">
              <span class="icon-profile cursor" id="iconProfile" @click="openProfileDropdown()"></span>
              <div class="entity-container" id="profileDropdown">
                <div class="entity-list">
                  <div class="entity">
                    <!-- <img
                            class="entity-img"
                            v-if="legalEntity.logoURL"
                    :src="legalEntity.logoURL" alt />-->
                    <img class="entity-img" src="@/assets/nature.jpg" alt />
                    <div class="entity-text">{{name}} </div>
                  </div>
                </div>
                <!-- <div class="btn-container1">
                  <div class="btn-signout" @click="companyPoliciesEvent">Company Policies</div>
                </div> -->
                <div class="divider"></div>
                <div class="btn-container1">
                  <!-- <div class="btn-signout">
                        View Policies
                      </div>
                      <div class="divider">
                  </div>-->
                  <div class="btn-signout" @click="accountSettingsEvent">Account Settings</div>
                </div>
                <div class="divider"></div>
                <!-- <div class="btn-container1">
                  <div class="btn-signout disabledMode">Help Desk &amp; FAQ</div>
                </div> -->
                <div class="divider"></div>
                <!-- $router.push('/onboarding/legal_entities/addLegalEntity') -->
                <div class="btn-container1">
                  <!-- <button class="btn-add-entity" @click="goToLegalEntity()">Add Legal Entity</button> -->
                  <div class="btn-signout" @click="signout()">Signout</div>
                </div>
                <div class="copy-right">© Paylief by Teamlease</div>
              </div>
            </div>
            <!-- <div class="links">
                <span class="icon-settings"></span>
            </div>-->
          </div>
        </div>
      </div>
    </header>
    <entity-change-window v-show="showModal" @back="showModal=false"></entity-change-window>

    <pop-up-message
      v-if="showConfirmDelete"
      :message="'Are you sure want to Signout ?'"
      :popupType="popupType"
      :popupHeaderMessage="'Confirm Signout'"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup-secondary" type="button" @click="cancelEvent()">Cancel</button>
          <button class="btn-popup" type="button" @click="confirmSignout()">Signout</button>
        </div>
      </template>
    </pop-up-message>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import EntityChangeWindow from "@/assets/animations/entityChange.vue";
import { debug } from "util";

export default {
  computed: {
    ...mapState({
      legalEntities: state => state.onboard.legal_entities.data,
      orgData: state => state.onboard.organization.data[0],
      orgid: state => state.onboard.organization.id,
      org_Id: (state) => state.auth.organisation_id,
       // to get current organization id - 25/11/2019
      authtoken: state => state.auth.token,
      name:state => state.auth.name
    }),
    ifAuditor() {  // Auditor role is use to hide some content
      return localStorage.getItem("userRole") == "AUDITOR" ? true : false;
    },
    ifClientAdmin(){
      return localStorage.getItem("userRole") == "CLIENTADMIN" ? true : false;
    },
    ifAdmin(){
      return localStorage.getItem("userRole") == "ADMIN" ? true : false;
    }
  },
  data() {
    return {
      showEntitiesContainer: false,
      showModal: false,
      showConfirmDelete: false,
      popupType: "ConfirmDelete",
      legalEntityPage:true
    };
  },
  components: {
    EntityChangeWindow
  },
  activated() {
    this.getentities();
  },
  mounted() {
   if(this.$route.params.entity_index){
    this.legalEntityPage=false
   }
    console.log(this.orgData)
    this.getentities();
    window.onclick = function(event) {
      if (!event.target.matches(".icon-profile")) {
        var dropdowns = document.getElementsByClassName("entity-container");
        var i;
        for (i = 0; i < dropdowns.length; i++) {
          var openDropdown = dropdowns[i];
          if (openDropdown.classList.contains("show")) {
            openDropdown.classList.remove("show");
          }
        }
      }
      window.onscroll = function(event) {
        var dropdowns = document.getElementsByClassName("entity-container");
        var i;
        for (i = 0; i < dropdowns.length; i++) {
          var openDropdown = dropdowns[i];
          if (openDropdown.classList.contains("show")) {
            openDropdown.classList.remove("show");
          }
        }
      };
    };
  },
  methods: {
    ...mapActions({
      act_signOut: "auth/signOut",
      act_fetchle: "onboard/legal_entities/fetchAll",
      act_changeMode: "onboard/legal_entities/changeMode"
    }),
    getentitiesdropdown() {
      this.showEntitiesContainer = !this.showEntitiesContainer;
      this.getentities();
    },
    async getentities() {
      try {
        if(ifClientAdmin){
          let res = await this.act_fetchle(this.org_Id);
        }else{
          let res = await this.act_fetchle(this.orgid);
        }
      } catch (err) {
        //console.log(err);
      }
    },
    entitySelected(selectedEntity) {
      this.showModal = true;
      this.showEntitiesContainer = false;
    },
    openProfileDropdown() {
      document.getElementById("iconProfile").classList.toggle("active");
      document.getElementById("profileDropdown").classList.toggle("show");
    },

    cancelEvent() {
      this.showConfirmDelete = false;
    },
    gotoHome() {
      this.$router.push("/welcome");
    },
    goToLegalEntity() {
      //start of sending editmode as false
      this.act_changeMode({ editMode: false, record: {} });
      //End of sending editmode as false
      this.$router.push("/onboarding/legal_entities/addLegalEntity");
    },
    signout() {
      this.showEntitiesContainer = !this.showEntitiesContainer;
      this.showConfirmDelete = true;
    },

    async confirmSignout() {
      try {
        let res = await this.act_signOut();
        //console.log("res", res);
        if (res.status == 200) {
          this.showConfirmDelete = false;
          this.$router.push({
            path: `/signin`
          });
          window.localStorage.clear();
          localStorage.removeItem("heartBeat")
          window.location.reload()
          window.sessionStorage.clear();
        }
      } catch (err) {
        //console.log("error msg", err.message);
        this.toast = true;
        this.errmsg = err.message;
      }

      this.showConfirmDelete = false;
    },

    companyPoliciesEvent() {
        this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/companyPolicies/companyPolicies`,
        });
    },

    accountSettingsEvent() {
      this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/accountSettings/changePasswordUser`,
        });
    }
    
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/dashboard/_variables.scss"; // variables
@import "../../scss/_header.scss"; // Header

.cursor {
  cursor: pointer;
}
.links {
  cursor: pointer;
  // .entity-container {
  //   display: none;
  // }
  // &:hover {
  //   .entity-container {
  //     z-index: 0;
  //     display: block;
  //   }
  // }
}
.show {
  display: block !important;
}
.entity-container {
  // background-color: white;
  display: none;
  z-index: 0;
  width: 218px;
  //height: 280px;
  border-radius: 4px;
  background: url("~@/assets/dashboard/bg_menu.png");
  background: rgba(10, 10, 10, 0.9999);
  -webkit-backdrop-filter: blur(14px);
  backdrop-filter: blur(14px);
  box-shadow: 2px 2px 6px 0 rgba(0, 0, 0, 0.15);
  border: solid 0.8px #131e24;
  position: fixed;
  right: 0px;
  top: 40px;
  padding-bottom: 20px;
  .entity-list {
    // height: 70%;
    // overflow-y: scroll;
    // scrollbar-color: black;
    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
      height: 50px;
      background-color: #666;
      border: 1px solid #eee;
      -webkit-border-radius: 6px;
    }
    .entity {
      // padding: 20px;
      width: 218px;
      height: 158px;
      padding: 26px 0px;
      display: block;
      background: #131e24;
      align-items: center;
      // &:not(:first-child) {
      //   background-color: #f9f9f9;
      // }
      // &:first-child {
      //   background-color: $color-white;
      //   padding: 30px 20px 30px 20px;
      // }
      // &:not(:last-child) {
      //   border-bottom: solid 0.8px #c6c9c8;
      // }
      .entity-img {
        height: 70px;
        width: 70px;
        border-radius: 50%;
        margin-right: 20px;
        display: block;
        margin: 0 auto;
      }
      .entity-text {
        text-align: center;
        color: #fff;
        padding-top: 16px;
        font-weight: bold;
        font-size: 16px;
      }
    }
  }
  .copy-right {
    font-size: 10px;
    color: #f0f0f0;
    text-align: center;
  }
}
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
  height: 50px;
  background-color: #666;
  border: 1px solid #eee;
  -webkit-border-radius: 6px;
}
.entity-container::before {
  bottom: 100%;
  right: 10px;
  border: 0.8px solid #c6c9c8;
  // content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-color: transparent;
  border-bottom-color: #131e24;
  border-width: 4px 10px 8px 10px;
}

.btn-container2 {
  border-top: solid 0.8px #c6c9c8;
  position: absolute;
  width: 100%;
  bottom: 0px;
  display: flex;
  justify-content: flex-end;
  padding: 15px;
  *:nth-child(n) {
    margin-right: 20px;
  }
  .btn-add-entity {
    background-color: $color-primary;
    color: $color-white;
    min-width: 70px;
    border-radius: 4px;
    height: 30px;
    font-size: 12px;
    padding: 5px 10px 5px 10px;
  }
  .btn-signout {
    font-size: 12px;
    padding: 5px;
    float: left;
    font-weight: bold;
    cursor: pointer;
  }
}
.btn-container1 {
  // border-top: solid 0.8px #c6c9c8;
  //     position: absolute;
  width: 100%;
  padding: 7px 0px;
  /* bottom: 65px; */
  // display: -webkit-box;
  // display: -ms-flexbox;
  /* display: flex; */
  // -webkit-box-pack: center;
  // -ms-flex-pack: center;
  // justify-content: center;
  // -webkit-box-align: center;
  // -ms-flex-align: center;
  // align-items: center;
  .btn-signout {
    font-size: 12px;
    /* width: 50%; */
    padding: 0px 12px;
    color: #fff;
    text-align: left;
    font-weight: 500;
  }
}
.divider {
  border-bottom: solid 1px #cecece;
  opacity: 0.16;
  margin: 0px 10px;
}
.backdrop {
  background: rgba(10, 10, 10, 0.51);
  backdrop-filter: blur(14px);
  height: 100%;
  width: 100%;
}
.navbar {
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 2;
  width: 100%;
  background: url("~@/assets/dashboard/nav_image.png");
  background-repeat: no-repeat;
  background-size: cover;
  // z-index: -7;
}
.sidenavLogo {
  padding: 5px 0px 5px 18px;
}
.headerSearchIcon {
  position: relative;
  outline: none;
  top: 9px;
  right: -27px;
  .Icon {
    color: #d5d5d5;
    font-size: 20px;
    position: relative;
    top: -3px;
  }
}
.searchText {
  padding-left: 30px !important;
  background: rgba(10, 10, 10, 0.51) !important;
  border: solid 1px #2d3236 !important;
  color: #d5d5d5 !important;
}
.legalentityName{
  margin-left:10rem;
   margin-top:1rem;
    position: absolute;
    z-index:15;
    font-weight: bold;
    font-size: larger;
    color:#eee;
    position: absolute;
    right:0;
    margin-right:4rem
}
</style>
